import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { MultiApprovalData } from '../types';
import { ACTION_TYPES } from './types';

export type FetchMultiApprovalState = {
  data: MultiApprovalData[];
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type FetchChildMultiApprovalState = {
  data: MultiApprovalData[];
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type SubmitMultiApprovalState = {
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type FetchIsParentApprovalActive = {
  data: boolean | null;
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type MultiApprovalStateState = {
  fetch: FetchMultiApprovalState;
  fetchChild: FetchChildMultiApprovalState;
  submit: SubmitMultiApprovalState;
  childSubmit: SubmitMultiApprovalState;
  parentActive: FetchIsParentApprovalActive;
  activeRule: FetchMultiApprovalState;
};

const initialState: MultiApprovalStateState = {
  fetch: {
    data: [],
    loading: false,
    isSuccess: false,
    error: '',
  },
  fetchChild: {
    data: [],
    loading: false,
    isSuccess: false,
    error: '',
  },
  submit: {
    loading: false,
    isSuccess: false,
    error: '',
  },
  childSubmit: {
    loading: false,
    isSuccess: false,
    error: '',
  },
  activeRule: {
    data: [],
    loading: false,
    isSuccess: false,
    error: '',
  },
  parentActive: {
    data: null,
    loading: false,
    isSuccess: false,
    error: '',
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.MULTI_APPROVAL_FETCH:
      return update(state, {
        fetch: {
          loading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.MULTI_APPROVAL_FETCH_SUCCESS:
      return update(state, {
        fetch: {
          $merge: {
            data: payload.data,
            loading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.MULTI_APPROVAL_FETCH_FAILED:
      return update(state, {
        fetch: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.CHILD_MULTI_APPROVAL_FETCH:
      return update(state, {
        fetchChild: {
          loading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.CHILD_MULTI_APPROVAL_FETCH_SUCCESS:
      return update(state, {
        fetchChild: {
          $merge: {
            data: payload.data,
            loading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.CHILD_MULTI_APPROVAL_FETCH_FAILED:
      return update(state, {
        fetchChild: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.MULTI_APPROVAL_SUBMIT:
      return update(state, {
        submit: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.MULTI_APPROVAL_SUBMIT_SUCCESS:
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            isSuccess: !payload.reason && payload.status_code === 200,
          },
        },
      });

    case ACTION_TYPES.MULTI_APPROVAL_SUBMIT_FAILED:
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });

    case ACTION_TYPES.CHILD_MULTI_APPROVAL_SUBMIT:
      return update(state, {
        childSubmit: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.CHILD_MULTI_APPROVAL_SUBMIT_SUCCESS:
      return update(state, {
        childSubmit: {
          $merge: {
            loading: false,
            isSuccess: !payload.reason && payload.status_code === 200,
          },
        },
      });

    case ACTION_TYPES.CHILD_MULTI_APPROVAL_SUBMIT_FAILED:
      return update(state, {
        childSubmit: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });

    case ACTION_TYPES.ACTIVE_MULTI_APPROVAL_FETCH:
      return update(state, {
        activeRule: {
          loading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.ACTIVE_MULTI_APPROVAL_FETCH_SUCCESS:
      return update(state, {
        activeRule: {
          $merge: {
            data: payload.data,
            loading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.ACTIVE_MULTI_APPROVAL_FETCH_FAILED:
      return update(state, {
        activeRule: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });

    case ACTION_TYPES.CHILD_MULTI_APPROVAL_ACTIVE_FETCH:
      return update(state, {
        parentActive: {
          loading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.CHILD_MULTI_APPROVAL_ACTIVE_FETCH_SUCCESS:
      return update(state, {
        parentActive: {
          $merge: {
            data: payload.data,
            loading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.CHILD_MULTI_APPROVAL_ACTIVE_FETCH_FAILED:
      return update(state, {
        parentActive: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });

    default:
      return state;
  }
};
